import React from 'react'
import { PageHeader } from 'SRC/ui'
import { imagesCDN } from 'src/core/constants'
import { CookiesHelper } from 'src/core/cookiesHelper/CookiesHelper'
import { Preloader } from 'SRC/ui/Preloader'
import { fetchFavouriteProfiles } from '../../../actions'
import { getSelectableUserTypes } from 'SRC/modules/common/selectors'
import {
  getProfileLoading,
  getFavouriteProfilesLoading,
  getFavouriteProfiles
} from '../../../selectors'
import { getProfilePaginationParams } from '../../../pagination/selectors'
import { ProfileApi } from '../../../api'
import { Links } from 'SRC/modules/common/components/Pagination'
import { isUserOnline } from 'src/utils'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Router from 'next/router'

export class SavedProfiles extends React.Component {
  constructor (props) {
    super(props)

    const { paginationParams } = props

    this.cookiesHelper = new CookiesHelper()
    this.profielApi = new ProfileApi()

    this.state = {
      profileType: paginationParams.type || 0
    }
  }

  updateProfileType = async profileType => {
    if (this.state.profileType !== profileType) {
      const userId = this.cookiesHelper.get('userId')
      const token = this.cookiesHelper.get('token')

      if (userId && token) {
        await this.props.fetchFavouriteProfiles(userId, token, profileType, 1, this.props.paginationParams)
        this.setState({ profileType })
      }
    }
  }

  getBaseUrl = () => {
    return {
      href: {
        pathname: `/profile`,
        query: {
          page: 'sacuvani-profili'
        }
      },
      as: `/profil/sacuvani-profili`
    }
  }

  getPageCount = () => Math.ceil((this.props.paginationParams.count) / this.props.paginationParams.countPerPage)

  getPages = (pageCount = 1) => {
    const pages = []
    const baseUrl = this.getBaseUrl()
    const current = Number(this.props.paginationParams.currentPage)
    for (let i = 1; i <= pageCount; i++) {
      pages.push({
        number: i,
        isCurrent: i === current,
        href: {
          pathname: baseUrl.href.pathname,
          query: { ...baseUrl.href.query, pageNumber: i }
        },
        as: {pathname: baseUrl.as, query: {pageNumber: i}}
      })
    }
    return pages
  }

  getPrevUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) - 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: {pageNumber: Number(this.props.paginationParams.currentPage) - 1}
    }
  })

  getNextUrl = () => ({
    href: {
      pathname: this.getBaseUrl().href.pathname,
      query: {
        ...this.getBaseUrl().href.query,
        pageNumber: Number(this.props.paginationParams.currentPage) + 1
      }
    },
    as: {
      pathname: this.getBaseUrl().as,
      query: {pageNumber: Number(this.props.paginationParams.currentPage) + 1}
    }
  })

  goToProfile = (username, userType) => {
    if (userType !== 'korisnik') {
      const asUrl = `/${userType}/${username}`

      const href = {
        pathname: `/user`,
        query: {username, userType}
      }

      const as = {pathname: asUrl}

      Router.push(href, as)
    }
  }

  removeFavouriteProfile = async profileId => {
    const userId = this.cookiesHelper.get('userId')
    const token = this.cookiesHelper.get('token')

    if (userId && token) {
      const result = await this.profielApi.removeFavouriteProfile(userId, token, profileId)

      if (result.hasOwnProperty('status') && result.status === 0) {
        this.props.fetchFavouriteProfiles(userId, token, this.state.profileType, 1, this.props.paginationParams)
      }
    }
  }

  render () {
    const { userTypesDropdown, paginationParams } = this.props
    const { profileType } = this.state

    const favouriteProfiles = this.props.favouriteProfiles(profileType)
    const pageCount = this.getPageCount()
    const pages = this.getPages(pageCount)
    const currentPage = Number(paginationParams.currentPage)
    const isFirstPage = currentPage === 1
    const isLastPage = currentPage === pageCount
    const prevUrl = this.getPrevUrl()
    const nextUrl = this.getNextUrl()
    const selectedUserType = userTypesDropdown.find(userType => userType.id === profileType)

    console.log('favouriteProfiles', favouriteProfiles)
    return (
      <section className='saved-profiles'>
        <PageHeader key='header'>Sačuvani korisnici</PageHeader>
        
        <div className='poruke-pretraga'>
          <div className='custom-select'>
            <a href='#'>
              <i className={selectedUserType.icon} />
              {selectedUserType.label}
            </a>
            <ul>
              {this.props.userTypesDropdown.length
                ? this.props.userTypesDropdown.map(dropdownItem =>
                  <li key={dropdownItem.key}>
                    <a href='javascript:void(0)' onClick={() => this.updateProfileType(dropdownItem.id)}>
                      <i className={dropdownItem.icon} />
                      {dropdownItem.label}
                    </a>
                  </li>)
                : null}
            </ul>
          </div>
        </div>

        {!this.props.isFavouriteProfilesLoading
          ? <div className={`sacuvani-korisnici ${favouriteProfiles.elements.length ? '' : 'profile-content-text_no-content'}`}>
            {favouriteProfiles.elements.length ? favouriteProfiles.elements.map(favouriteProfile => (
              <div className={`sacuvani-korisnici-item ${favouriteProfile.premium ? 'pro-korisnik' : ''}`}
                key={favouriteProfile.username}>
                <div className='sacuvani-korisnik-img'>
                  {favouriteProfile.logo && favouriteProfile.logo.fd
                    ? <img className='' src={`${imagesCDN}${favouriteProfile.logo.fd}`} />
                    : <i className='ico-user-avatar-musko ico' />}
                </div>

                <div className='sacuvani-korisnik-info'>
                  <p>{favouriteProfile.name}</p>
                  <p>{favouriteProfile.username}</p>
                  <div className={`online-status ${isUserOnline(favouriteProfile.active) ? 'online' : 'offline'}`}>
                    <span />
                    {isUserOnline(favouriteProfile.active) ? 'Online' : 'Offline'}
                  </div>
                </div>

                <div className='sacuvani-korisnik-lokacija-link'>
                  <div className='sacuvani-korisnik-lokacija'>
                    <i className='ico-lokacija ico' />
                    <p>{favouriteProfile.userAddresses && favouriteProfile.userAddresses.length
                      ? (favouriteProfile.userAddresses[0].city ? favouriteProfile.userAddresses[0].city.name : '') : ''}</p>
                  </div>
                  <div className='sacuvani-korisnik-link'>
                    <a href='javascript:void(0)'
                      onClick={() => this.goToProfile(favouriteProfile.username, favouriteProfile.type.seo)}>
                      vidi profil
                    </a>
                  </div>
                </div>

                <a className='obrisi-sacuvanog-korisnika' href='javascript:void(0)'
                  title='Obriši' onClick={() => this.removeFavouriteProfile(favouriteProfile.id)}>
                  <i className='ico-nema ico' />
                </a>

              </div>)) : <div className='profile-content-text__no-content-text'>Nema sačuvanih korisnika</div>}
          </div> : <Preloader />}
        
        {pages ? (
          <Links
            isFirstPage={isFirstPage}
            isLastPage={isLastPage}
            prevUrl={prevUrl}
            nextUrl={nextUrl}
            pages={pages}
          />
        ) : null}
        {this.props.isProileLoading ? <Preloader /> : null}
      </section>
    )
  }
}

const mapStateToProps = state => {
  const userTypes = getSelectableUserTypes(state)

  const userTypesDropdown = [
    {
      id: 0,
      key: 'all',
      label: 'Prikazano sve',
      icon: 'ico-sacuvaj-oglas ico'
    },
    ...userTypes.map(userType => ({
      id: userType.id,
      key: userType.seo,
      label: userType.name,
      icon: userType.icon || 'ico-registracija-korisnik ico'
    }))
  ]

  userTypesDropdown.unshift()

  return {
    userTypesDropdown,
    isProileLoading: getProfileLoading(state),
    isFavouriteProfilesLoading: getFavouriteProfilesLoading(state),
    paginationParams: getProfilePaginationParams(state),
    favouriteProfiles: type => getFavouriteProfiles(state, type)
  }
}

SavedProfiles.propTypes = {
  userTypesDropdown: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string
  })).isRequired,
  isProileLoading: PropTypes.bool.isRequired,
  isFavouriteProfilesLoading: PropTypes.bool.isRequired,
  fetchFavouriteProfiles: PropTypes.func.isRequired,
  favouriteProfiles: PropTypes.shape({
    elements: PropTypes.array.isRequired,
    count: PropTypes.number.isRequired
  }).isRequired,
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    countPerPage: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    type: PropTypes.number
  })
}

SavedProfiles.defaultProps = {
  isProileLoading: false,
  userTypesDropdown: []
}

export default connect(mapStateToProps, { fetchFavouriteProfiles })(SavedProfiles)
